<template>
  <div>
    <div class="mt-4">
      <v-card-title>
        <v-row class="py-2">
          <v-col lg="4" md="4" sm="2" class="col-12">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn small class="mx-4" v-on="on" fab dark color="primary" @click="agregar()">
                  <v-icon small dark>fas fa-user-plus</v-icon>
                </v-btn>
              </template>
              <span>Agregar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn small class="mx-4" v-on="on" fab dark color="primary" @click="agregarMultiple()">
                  <v-icon small dark>fas fa-users</v-icon>
                </v-btn>
              </template>
              <span>Asignación Múltiple</span>
            </v-tooltip>
          </v-col>
          <v-spacer></v-spacer>
          <v-col lg="3" md="3" sm="3" class="col-12">
            <v-select :items="filtroOpciones" v-model="filtro"> </v-select>
          </v-col>
          <v-col lg="4" md="4" sm="4" class="col-12">
            <v-text-field
              class="px-4"
              v-model="search"
              append-icon=" fas fa-search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        v-model="seleccionado"
        :single-select="false"
        item-key="idmovcampamentopersonal"
        show-select
        :headers="headers"
        :items="desserts"
        :search="search"
        class="border"
        multi-sort
        :mobile-breakpoint="0"
        :items-per-page="pagina"
        no-results-text="No se encontraron datos"
        no-data-text="No se encontraron datos"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-divider class="mx-4" inset vertical></v-divider>
            <div class="text-center">
              <v-menu bottom offset-y ref="openMenu">
                <template v-slot:activator="{ on: menu }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn class="mx-2" fab small color="primary" v-on="{ ...tooltip, ...menu }">
                        <v-icon small>fas fa-ellipsis-v</v-icon>
                      </v-btn>
                    </template>
                    <span>Acciones</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-item @click.stop="cambiarEstado()">
                    <v-list-item-title> Dar de Baja </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-toolbar>
          <v-divider></v-divider>
        </template>
        <template v-slot:item.activo="{ item }">
          <v-icon color="red" small v-if="item.activo == 0">fas fa-square-full</v-icon>
          <v-icon color="green" small v-else-if="item.activo == 1">fas fa-square-full</v-icon>
        </template>
      </v-data-table>
    </div>
    <div v-if="showLoading" class="progress-background">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
    <v-dialog v-model="dialogDeshabilitar" persistent width="500">
      <v-card>
        <v-card-title class="headline">Observación</v-card-title>
        <div class="px-5">
          <v-textarea label="Motivo de Baja" :rules="rules" v-model="valueTxtArea"></v-textarea>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="cancelDialogDeshabilitar">Cancelar</v-btn>
          <v-btn color="primary" text @click="acceptDialogDeshabilitar">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="2000" :color="color">
      {{ text }}
      <v-btn :color="color == 'red' ? 'white' : 'primary'" text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import AsignacionService from '@/CYC/campamento/asignacion/services/AsignacionService';

export default {
  name: 'EmpleadosAsignadosLista',
  data: () => ({
    asignacionService: null,
    showLoading: false,
    search: '',
    dialogDeshabilitar: false,
    rules: [(v) => v.length > 0 || 'El campo es obligatorio.'],
    valueTxtArea: '',
    timeout: 2000,
    snackbar: false,
    text: '',
    color: '',
    filtro: '',
    filtroOpciones: [
      { text: 'TODOS', value: '' },
      { text: 'HABILITADOS', value: '1' },
      { text: 'DESHABILITADOS', value: '0' }
    ],
    dialog: false,
    nuevo: false,
    headers: [
      { text: 'idtrabajador', value: 'idtrabajador', width: 150 },
      { text: 'nombres', value: 'nombres', width: 400 },
      { text: 'idplanilla', value: 'idplanilla', width: 150 },
      { text: 'sexotrab', value: 'sexotrab', width: 150 },
      { text: 'idtipocampamento', value: 'idtipocampamento', width: 200 },
      { text: 'idsectorpadre', value: 'idsectorpadre', width: 150 },
      { text: 'idsector', value: 'idsector', width: 150 },
      { text: 'aldea', value: 'aldea', width: 150 },
      { text: 'carpa', value: 'carpa', width: 150 },
      { text: 'habitacion', value: 'habitacion', width: 150 },
      { text: 'cama', value: 'cama', width: 150 },
      { text: 'sexounid', value: 'sexounid', width: 150 },
      { text: 'iniciocontrato', value: 'iniciocontrato', width: 180 },
      { text: 'fincampamento', value: 'fincampamento', width: 180 },
      { text: 'observaciones', value: 'observaciones', width: 150 },
      { text: 'activo', value: 'activo', width: 100, align: 'center' }
    ],
    desserts: [],
    seleccionado: []
  }),
  computed: {
    pagina() {
      if (screen.width <= 600) return 5;
      else return 15;
    }
  },
  watch: {
    filtro() {
      this.initialize();
    }
  },
  methods: {
    openLoading() {
      this.showLoading = true;
    },
    closeLoading() {
      this.showLoading = false;
    },
    openDialogDeshabilitar() {
      this.dialogDeshabilitar = true;
    },
    closeDialogDeshabilitar() {
      this.dialogDeshabilitar = false;
    },
    cancelDialogDeshabilitar() {
      this.valueTxtArea = '';
      this.closeDialogDeshabilitar();
    },
    async acceptDialogDeshabilitar() {
      if (this.valueTxtArea.length <= 0) return;

      const data = [];
      const text = this.valueTxtArea;
      this.seleccionado.forEach((element) => {
        if (element.activo == 1) {
          data.push(element.idmovcampamentopersonal);
        }
      });

      this.cancelDialogDeshabilitar();
      this.seleccionado = [];
      if (data.length <= 0) {
        this.text = 'No se han seleccionado asignaciones activas.';
        this.snackbar = true;
        this.color = 'red';
        return;
      }
      await this.bajaObservacion(data, text);
    },
    cambiarEstado() {
      if (this.seleccionado.length > 0) {
        this.openDialogDeshabilitar();
      } else {
        this.snackbar = true;
        this.text = 'Seleccione al menos un elemento de la lista.';
        this.color = 'red';
      }
    },
    async initialize() {
      this.openLoading();
      const res = await this.asignacionService.get().execResource('distocupados', {
        idempresa: localStorage.getItem('emp'),
        idplanilla: '',
        activo: this.filtro
      });
      this.desserts = res;
      this.closeLoading();
    },
    async bajaObservacion(data, value) {
      this.openLoading();
      const res = await this.asignacionService.put().execResource('bajaobservacion', {
        data: data,
        value: value
      });
      this.closeLoading();
      this.text = res.message;
      this.color = '';
      this.snackbar = true;
      await this.initialize();
    },
    agregarMultiple() {
      this.$router.push({ path: '/campamento/asignacion/asignar_multiple' });
    },
    agregar() {
      this.$router.push({ path: '/campamento/asignacion/asignar' });
    },
    async seleccion(env) {
      await this.initialize(env);
    }
  },
  async mounted() {
    this.asignacionService = this.$httpService(new AsignacionService(), this);
    this.filtro = this.filtroOpciones[1].value;
    await this.initialize();
  }
};
</script>
